import { Beneficiary } from './Beneficiary';

class CreateBeneficiaryRequestDTO {
  name: string;
  data: Beneficiary;

  constructor(name: string, data: Beneficiary) {
    this.name = name;
    this.data = data;
  }
}

export { CreateBeneficiaryRequestDTO };
